const routes = [
  {
    path: 'promise',
    name: 'promise',
    component: () => import(/* webpackChunkName: "promise" */ '@/modules/promise/index.vue')
  },
];

export default routes;